export type OrderEntry = {
  personName: string;
  submitted: boolean;
  /** 자유 입력 제출이면 참여자가 적은 문장이 그대로 들어온다. */
  menuName: string | null;
  optionNames: string[];
  note: string;
  price: number;
  /** 메뉴판 밖의 자유 입력 제출. 집계·복사 텍스트는 menuName 만 보므로 표시용이다. */
  isCustom?: boolean;
};

export type MenuGroup = {
  label: string;
  count: number;
  personNames: string[];
};

function labelOf(entry: OrderEntry): string {
  const options = entry.optionNames.length > 0 ? ` (${entry.optionNames.join(", ")})` : "";
  const note = entry.note ? ` - ${entry.note}` : "";
  return `${entry.menuName ?? ""}${options}${note}`;
}

/** 메뉴+옵션+메모가 같은 주문을 하나로 묶는다. 카운터에서 그대로 읽을 수 있게. */
export function groupByMenu(entries: OrderEntry[]): MenuGroup[] {
  const groups = new Map<string, MenuGroup>();
  for (const entry of entries) {
    if (!entry.submitted || !entry.menuName) continue;
    const label = labelOf(entry);
    const found = groups.get(label);
    if (found) {
      found.count += 1;
      found.personNames.push(entry.personName);
    } else {
      groups.set(label, { label, count: 1, personNames: [entry.personName] });
    }
  }
  return [...groups.values()].sort((a, b) => b.count - a.count);
}

export function totalPrice(entries: OrderEntry[]): number {
  return entries.reduce((sum, e) => (e.submitted ? sum + e.price : sum), 0);
}

/** 카카오톡에 그대로 붙여넣는 텍스트. */
export function formatOrderText(menuboardName: string, entries: OrderEntry[]): string {
  const lines: string[] = [`[${menuboardName}] 주문 취합`, ""];

  for (const group of groupByMenu(entries)) {
    lines.push(`${group.label} x${group.count} — ${group.personNames.join(", ")}`);
  }

  lines.push("", `총 ${totalPrice(entries).toLocaleString("ko-KR")}원`);

  const pending = entries.filter((e) => !e.submitted).map((e) => e.personName);
  if (pending.length > 0) {
    lines.push(`아직 안 낸 사람: ${pending.join(", ")}`);
  }

  return lines.join("\n");
}
